import { Injectable } from '@angular/core';
import { AssetDirectoryStore } from './asset-directory.store';
import { AssetDirectoryQuery } from './asset-directory.query';
import { BaseFacade } from "../base/base.facade";
import { AssetDirectoryService } from './asset-directory.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { Observable } from 'rxjs';
import { AssetDirectoryModel } from './asset-directory.model';
import { map, tap } from 'rxjs/operators';
import { AssetService } from '../../squidex/services/asset.service';
import { ESchemaContentStatus } from '../base/enum';
import { Folder } from '../../squidex/models/folder.model';
import { guid, ID } from '@datorama/akita';
import { Content, ContentList } from '../../squidex';
import { FolderList } from '../../squidex/models/folder-list.model';

@Injectable({ providedIn: 'root' })
export class AssetDirectoryFacade extends BaseFacade {

  constructor(
    assetDirectoryService: AssetDirectoryService,
    assetDirectoryStore: AssetDirectoryStore,
    assetDirectoryQuery: AssetDirectoryQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService,
    private readonly directoryService: AssetDirectoryService
    ) {
    super(assetDirectoryService,
      assetDirectoryStore,
      assetDirectoryQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade('assetdirectory'),
      translateService,
      'assetdirectory-facade');
  }

  verifyExist(directory: string) {
    this.getCount(directory).subscribe(count => {
      if (count === 0) {
        let dir = new AssetDirectoryModel();

        this.setDataValue(dir.data, 'code', directory.toLowerCase().replace(' ', '_'));
        this.setDataValue(dir.data, 'name', directory);
        this.putNumber(dir.data, 'index', 1);

        this.createAsPublished(dir.data).subscribe();
      }
    });
  }

  getCount(folder: string): Observable<number> {
    let contentObject =
    {
        path: 'data.name.iv',
        op: "eq",
        value: folder
    }
    return this.filterCount(contentObject).pipe(map(val => ( val && 0 )));
  }

  getByName(name: string): Observable<AssetDirectoryModel[]> {

    const directoryObject =
    {
      path: 'data.name.iv',
      op: "eq",
      value: name
    }
    return this.getFilteredPagination(null, ESchemaContentStatus.Published, directoryObject) as Observable<AssetDirectoryModel[]>;
  }


  createDirectoryIfNotExist(folderName: string): Observable<string> {
    return this.getFolders().subscribe(folders => {
      const folderId: string = folders.items.find(item => item.folderName === folderName).id;
      if (folderId) {
        return folderId;
      } else {
        const newFolder = new Folder();
        newFolder.folderName = folderName
        return this.directoryService.createFolder(newFolder).subscribe();
      }
    }) as unknown as Observable<string>;
  }

  create(contentData: any): Observable<Content> {

    const folder = new Folder();
    folder.folderName = contentData.name.iv;
    this.createFolder(folder).subscribe();

    return super.create(contentData);
  }


  update(contentData: any, id: string, parentId: string = null ): Observable<Content> {

    const folder = new Folder();
    folder.folderName = contentData.name.iv;
    folder.id = id;
    // this.updateFolder(folder).subscribe();

    return super.update(id, contentData);
  }

  remove(id: ID, draftMode: boolean = false): Observable<Content> {
    this.deleteFolder(id).subscribe();
    return super.remove(id, true);
  }


  createFolder(folder: Folder): Observable<Folder> {
    if (folder) {
      return this.directoryService.createFolder(folder);
    } else {
      throw (new Error('data is null when trying to create asset'));
    }
  }

  updateFolder(folder: Folder): Observable<Folder> {
    if (folder) {
      return this.directoryService.updateFolder(folder);
    } else {
      throw (new Error('data is null when trying to create asset'));
    }
  }


  deleteFolder(folderId: ID): Observable<Folder> {
    return this.directoryService.deleteFolder(folderId);
  }


  getFolders(): Observable<FolderList> {
    return this.directoryService.getFolders() as Observable<FolderList>; 
  }

}
